import { get, post, put } from './request';

export function create(json, callback = () => { }) {
  return (dispatch, getState) => {
    dispatch({
      type: 'SUBCATEGORY_CREATE'
    });

    post(`subcategory`, { json }).then(
      result => {
        if (!result.response.ok) {
          callback(result.json);
          dispatch({ type: 'SUBCATEGORY_ERROR', error: result.response.statusText });
        } else {
          callback(null, result.json);
          dispatch({ type: 'SUBCATEGORY_CREATE_OK', subcategory: result.json });
        }
      }).catch(error => dispatch({ type: 'SUBCATEGORY_CREATE_ERROR', error }));
  };
}

export function update(_id, json, callback = () => { }) {
  return (dispatch, getState) => {
    dispatch({
      type: 'SUBCATEGORY_UPDATE'
    });

    put(`subcategory/${_id}`, { json }).then(
      result => {
        if (!result.response.ok) {
          callback(result.json);
          dispatch({ type: 'SUBCATEGORY_ERROR', error: result.response.statusText });
        } else {
          callback(null, result.json);
          dispatch({ type: 'SUBCATEGORY_UPDATE_OK', subcategory: result.json });
        }
      }).catch(error => dispatch({ type: 'SUBCATEGORY_UPDATE_ERROR', error }));
  };
}

export function find(_id, callback = () => { }) {
  return (dispatch, getState) => {
    dispatch({
      type: 'SUBCATEGORY_GET'
    });

    get(`subcategory/${_id}`, { json: true }).then(
      result => {
        if (!result.response.ok) {
          callback(result.json);
          dispatch({ type: 'SUBCATEGORY_ERROR', error: result.response.statusText });
        } else {
          callback(null, result.json);
          dispatch({ type: 'SUBCATEGORY_GET_OK', subcategory: result.json });
        }
      }).catch(error => dispatch({ type: 'SUBCATEGORY_GET_ERROR', error }));
  };
}

export function all(kwargs = {}, callback = () => { }) {
  return (dispatch, getState) => {
    dispatch({
      type: 'SUBCATEGORIES_GET'
    });

    const q = kwargs.q ? `&q=${kwargs.q}` : '';
    const limit = `?limit=${kwargs.limit || 10}`;
    get(`subcategories${limit}${q}`, { json: true }).then(
      result => {
        if (!result.response.ok) {
          callback(result.json);
          dispatch({ type: 'SUBCATEGORY_ERROR', error: result.response.statusText });
        } else {
          callback(null, result.json);
          dispatch({ type: 'SUBCATEGORIES_GET_OK', data: result.json });
        }
      }).catch(error => dispatch({ type: 'SUBCATEGORIES_GET_ERROR', error }));
  };
}

